<div class="chart-wrapper h-100 notranslate">
    <canvas baseChart class="bar h-100" height="500px" style="min-height: 500px;"
            [data]="chartData"
            [options]="defaultOptions"
            [type]="'scatter'"
            [plugins]="plugins">
    </canvas>
</div>
